export enum TaskStatus {
    InProgress = 'in_progress',
    Completed = 'completed',
    Failed = 'failed'
}
